import { ref } from "@vue/composition-api";
// export const useTable = (sortBy = ["name"], sortDesc = false) => {
export const useTable = (sortBy = "name", sortDesc = false) => {
    const table_options = ref({
        page: 1,
        itemsPerPage: 50,
        sortBy: sortBy,
        sortDesc: sortDesc,
        groupBy: "", // [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
    });

    let table_footer_props = {
        "items-per-page-options": [25, 50, 100, 1000]
    };

    const changeTableSort = column => {
        if (table_options.value.sortBy === column) {
            table_options.value.sortDesc = !table_options.value.sortDesc;
        } else {
            table_options.value = Object.assign(table_options.value, {
                sortBy: column,
                sortDesc: !table_options.value.sortDesc
            });
        }
    };
    const formatTableHeaderClass = (header, options) => {
        let classes = [];
        if (header.align) {
            classes.push("text-" + header.align);
        }
        if (header.sortable !== false && header["value"] !== "data-table-select") {
            classes.push("sortable");
        }
        if (header.value === options.sortBy) {
            classes.push("active");
            classes.push(options.sortDesc ? "desc" : "asc");
        }
        return classes.join(" ");
    };
    return { table_options, table_footer_props, changeTableSort, formatTableHeaderClass };
};
